<form name="formApproveReject">
    <div class="row">
        <div class="col-md-12">{{ "DATASET_DIALOG.CHOOSE" | translate }}</div>
    </div>
    <div class="row">
        <div class="col-md-12">&nbsp;</div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label>
                <input type="radio" [(ngModel)]="techApproveAction" value="techApprove" name="techApproveAction" (ngModelChange)="onTechApproveActionChanged()" />
                {{ "DATASET_DIALOG.LABEL.OKAY" | translate }}
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label>
                <input type="radio" [(ngModel)]="techApproveAction" value="techReject" name="techApproveAction" (ngModelChange)="onTechApproveActionChanged()" />
                {{ "DATASET_DIALOG.LABEL.NOT_OKAY" | translate }}
            </label>
        </div>
    </div>
    <div class="row">
        @if (techApproveAction === "techApprove") {
            <div class="col-md-12 mb-2">
                {{ "DATASET_DIALOG.TECH.OKAY.TEXT" | translate }}
            </div>
        }
        @if (techApproveAction === "techReject") {
            <div class="col-md-12 mb-2">
                {{ "DATASET_DIALOG.TECH.NOT_OKAY.TEXT" | translate }}
            </div>
        }
    </div>
    <div class="row">
        <div class="col-md-12">
            <textarea class="rejectcomment form-control" [(ngModel)]="dataset.manualApproveNote" name="manualApproveNote" (ngModelChange)="onManualApproveNoteChanged()"></textarea>
            <br />
            @if (techApproveAction === "techApprove" && !dataset.manualApproveNote) {
                <div class="alert alert-danger">{{ "DATASET_DIALOG.TECH.NOT_OKAY.COMMENT" | translate }}</div>
            }
        </div>
    </div>
</form>
